import React, {ReactNode} from "react";
import classNames from "classnames";

import {CloseIcon} from "../icons/CloseIcon";

import "./RightMenuHeader.css";

export interface RightMenuHeaderProps {
    title: ReactNode;
    isOpen: boolean;
    localeKey?: string;
    onClose: (event: React.MouseEvent) => void;
}

export const RightMenuHeader = ({title, isOpen, localeKey, onClose}: RightMenuHeaderProps) => {
    return (
        <div
            key={localeKey}
            className={classNames({
                "RightMenuHeader title-medium-bold": true,
                "RightMenu__header-animation--open": isOpen,
            })}
        >
            {title}
            {isOpen && (
                <CloseIcon
                    className="RightMenuHeader__icon"
                    size={24}
                    additionalPadding={12}
                    onClick={onClose}
                />
            )}
        </div>
    );
};
